import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Behandlungsanfrage } from './behandlungsanfrage';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';

@Injectable()
export class BehandlungsanfrageService {
    constructor(
        private readonly http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    getById(id: number): Observable<Behandlungsanfrage> {
        return this.http.get<Behandlungsanfrage>(
            this.apiBaseUrl + 'behandlungsanfrage/read_one.php?bestellung_id=' + id,
        );
    }

    save(bi: Behandlungsanfrage, mandantIdKunde: number): Observable<Behandlungsanfrage> {
        let headers;
        if (mandantIdKunde !== undefined) {
            headers = { 'MANDANTID-KUNDE': mandantIdKunde.toString() };
        }
        return this.http.post<Behandlungsanfrage>(this.apiBaseUrl + 'behandlungsanfrage/update.php', bi, {
            headers: headers,
        });
    }

    updateBehandlungsanfrage(
        behandlungsanfrage: Behandlungsanfrage,
        mandantIdKunde: number,
    ): Observable<Behandlungsanfrage> {
        let headers;
        if (mandantIdKunde !== undefined) {
            headers = { 'MANDANTID-KUNDE': mandantIdKunde.toString() };
        }
        return this.http.post<Behandlungsanfrage>(
            this.apiBaseUrl + 'behandlungsanfrage/update.php',
            behandlungsanfrage,
            { headers: headers },
        );
    }

    transformToAbgabebeleg(behandlungsanfrage: Behandlungsanfrage): Observable<any> {
        return this.http.post(this.apiBaseUrl + 'abgabebeleg/transform.php', behandlungsanfrage);
    }

    duplicate(behandlungsanfrage: Behandlungsanfrage, mandantIdKunde?: number): Observable<Behandlungsanfrage> {
        let headers = null;
        if (mandantIdKunde !== undefined) {
            headers = { 'MANDANTID-KUNDE': mandantIdKunde.toString() };
        }
        return this.http.post<Behandlungsanfrage>(
            this.apiBaseUrl + 'behandlungsanfrage/duplicate.php',
            behandlungsanfrage,
            { headers: headers },
        );
    }
}
